<template>
    <PopoverRight ref="popoverMenu" width="550px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">编辑400月最低消费</h1>
            <div class="mobile-bind-group">
                <p>注：</p>
                <p>1、公共大号类型：与站点为1对多的关系；</p>
                <p>2、独立大号类型：与站点为1对1的关系；</p>
                <p>3、已绑定独立大号的站点不允许再新增绑定公共大号;</p>
                <p>4、月最低消费输入0代表按照实际通话进行扣费;</p>
                <p>5、使用公共大号时，月最低消费配置不生效，均按实际通话进行扣费;</p>

            </div>
            <el-form class="form-container" :model="hotlineInfo" :rules="hotlineRules" ref="userInfoForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">号码类型</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-input disabled   v-model="hotlineInfo.type_text">
                        </el-input>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">400号码</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item >
                           <el-input disabled   v-model="hotlineInfo.hotline_number">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">月最低消费</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="minimum_charge_yuan">
                            <el-input placeholder="请输入月最低消费"  v-model="hotlineInfo.minimum_charge_yuan">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-button">
                    <el-button type="primary" @click="submitForm('userInfoForm')">保 存</el-button>
                    <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>

<script>
    import PopoverRight from '@/components/popoverRight/index'
    import { validateNumber } from '@/utils/validate'
    export default {
        name: "bindLine",
        components: {
            PopoverRight
        },
        props: {
            callback: Function,
        },
        data () {
            return {
                hotlineInfo: {
                    minimum_charge_yuan:'',
                    hotline_number:'',
                    type_text:''
                },
                index:null,
                hotlineRules: {
                     minimum_charge_yuan: [
                        { required: true, message: '请填写0-9999之间的月最低消费', trigger: 'blur' },
                        {  result: '月最低消费', trigger: 'blur',
                            validator:validateNumber, type:1,max: 9999,min:0, }
                    ],
                },
            }
        },
        methods: {
            open (data,index) {
                this.hotlineInfo = data
                this.index = index
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
            },
            /** 关闭右侧悬浮层 */
            hide () {
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide();
                this.$refs.userInfoForm && this.$refs.userInfoForm.clearValidate()
            },
            submitForm (formName) {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        this.hide();
                        this.hotlineInfo.minimum_charge=this.hotlineInfo.minimum_charge_yuan
                        this.callback(this.hotlineInfo,this.index)
                    }
                })
            },
        }
    }
</script>

<style scoped>
.mobile-bind-group{
    margin-top: 15px;
    line-height: 24px;
    font-size: 13px;
    color: #999;
    background: #fafafa;
    padding: 10px 20px;
}
.popover-slider-bar .form-container .form-item .form-label{
  width:90px!important;
}
</style>